import { Column, Carousel, Row, CarouselSlide } from '@vp/swan'
import Tile from './Tile'
import React from 'react'

const CarouselTilesList = (props) => {
  const {
    tiles,
    visibleTiles,
    carouselResponsiveSettings,
    loadType,
    enableCampaignCallouts,
    trackingPageZone,
    id,
    tileSkin,
    useNewTiles,
    tileRow,
    sectionHeader,
    carouselA11yText,
    locale,
  } = props

  const { a11yCarouselLabel, a11yCarouselRole, a11yCarouselSlide, a11yCarouselNext, a11yCarouselPrevious, a11yCarouselVisible } = carouselA11yText

  return (
    <Row>
      <Column span={12} pr="2" pl="2">
        <Carousel
          slidesToShow={visibleTiles}
          slidesToScroll={visibleTiles}
          infinite={false}
          gridGutters
          progressIndicator="none"
          responsive={carouselResponsiveSettings}
          aria-label={`${a11yCarouselLabel}: ${sectionHeader}`}
          aria-roledescription={a11yCarouselRole}
          accessibleTextForPrevious={`${sectionHeader}: ${a11yCarouselPrevious}`}
          accessibleTextForNext={`${sectionHeader}: ${a11yCarouselNext}`}
          accessibleTextForVisibleSlides={a11yCarouselVisible}
          arrowVerticalPosition={getCarouselArrowsVerticalPosition(tileRow)}
          id={id.replaceAll(' ', '')}
        >
          {tiles.map((tile, index) => (
            <CarouselSlide data-testid="slick-item" key={index} aria-roledescription={a11yCarouselSlide}>
              <Tile
                loadType={loadType}
                data={tile}
                position={index + 1}
                trackingPageZone={trackingPageZone}
                enableCampaignCallouts={enableCampaignCallouts}
                useNewTiles={useNewTiles}
                tileSkin={tileSkin}
                locale={locale}
                marginBottom={0}
              />
            </CarouselSlide>
          ))}
        </Carousel>
      </Column>
    </Row>
  )
}

export const getCarouselArrowsVerticalPosition = (row) => {
  switch (row) {
    case '5':
      return '35%'
    default:
      return '40%'
  }
}

export default CarouselTilesList
